// import { take, call, put, select } from 'redux-saga/effects';

// Individual exports for testing

import { call, put, all, spawn, takeEvery } from 'redux-saga/effects';
import {
  GET_SPLIT_VENDOR_OPTIONS_URL,
  VENDOR_DATA_BY_ID_URL,
} from 'constants/url';
import request from 'utils/request';
import {
  CREATE_KYC_URL,
  DOWNLOAD_DOC_URL,
  GET_VENDOR_KYC_DOCS_URL,
  GET_VENDOR_OD_BALANCE_URL,
  IN_BENE_CREATION,
  IN_BENE_UPDATE_VENDOR_FIELDS,
  INITIATE_VENDOR_OD_URL,
  MINIMUM_VENDOR_BALANCE,
  UPDATE_VENDOR_FIELDS,
  UPDATE_VENDOR_URL_NEW,
  VENDOR_DATA_BY_ID,
} from '../Vendors/constants';
import { ADJUST_BALANCE_URL } from '../Adjustments/constants';
import { showToast } from '../Toast/actions';
import {
  disableLoaderAction,
  saveKycResponseAction,
  saveSettlementConfigAction,
  saveVendorByIdAction,
  saveVendorDetailsAction,
  saveVendorDocsAction,
  saveVendorKycDetailsAction,
} from './actions';
import {
  ADJUST_BALANCE,
  DOWNLOAD_DOC,
  GET_DOCS_BY_USER,
  GET_DOCS_BY_USER_URL,
  GET_KYC_DOCS,
  GET_SETTLEMENT_CONFIG,
  GET_VENDOR_KYC_DETAILS,
  GET_VENDOR_OD_BALANCE,
  UPDATE_VENDOR,
  UPLOAD_KYC_DATA,
  UPLOAD_VENDOR_DOCS,
  UPLOAD_VENDOR_DOCS_URL,
  VERIFY_CIN,
  VERIFY_CIN_URL,
  VERIFY_GST,
  VERIFY_GST_URL,
  VERIFY_PAN,
  VERIFY_PAN_URL,
  INITIATE_VENDOR_OD,
} from './constants';

export function* getVendorDataById({ data: { vendorId, cb, errorCb } }) {
  try {
    const { url, method } = VENDOR_DATA_BY_ID_URL;
    const updatedUrl = url.replace('$vendor_id$', vendorId);
    const options = { method };
    const response = yield call(request, updatedUrl, options);
    yield put(saveVendorDetailsAction(response));
    if (cb) cb(response);

    yield put(saveVendorByIdAction(response));
  } catch (err) {
    if (errorCb) errorCb();
    else {
      yield put(disableLoaderAction());
      yield put(showToast(err));
    }
  }
}

export function* getVendorKycDetails({ data: { vendorId, updatedBy } }) {
  try {
    const { url, method } = UPDATE_VENDOR_URL_NEW;
    const updatedUrl = url.replace('$vendor_id$', vendorId);
    const options = {
      method,
      body: JSON.stringify({ updatedBy }),
    };
    const response = yield call(request, updatedUrl, options);
    yield put(saveVendorKycDetailsAction(response));
  } catch (err) {
    showToast(err);
    disableLoaderAction();
  }
}

export function* getKycDocs({ data: { vendorId } }) {
  try {
    const { url, method } = GET_VENDOR_KYC_DOCS_URL;
    const updatedUrl = url.replace('$vendor_id$', vendorId);
    const response = yield call(request, updatedUrl, { method });
    yield put(saveKycResponseAction(response));
  } catch (err) {
    showToast(err);
    disableLoaderAction();
  }
}

export function* adjustBalance({ data: { data, successCb, errorCb } }) {
  try {
    const { url, method } = ADJUST_BALANCE_URL;
    const { merchantVendorId, ...body } = data;
    const options = {
      method,
      body: JSON.stringify(body),
    };
    const updatedUrl = url.replace('$merchant_vendor_id$', merchantVendorId);
    yield call(request, updatedUrl, options);
    yield put(
      showToast({
        message: 'Vendor & merchant balances updated successfully',
        type: 'SUCCESS',
      }),
    );
    if (successCb) successCb();
  } catch (err) {
    yield put(showToast(err));
  } finally {
    if (errorCb) errorCb();
  }
}

export function* downloadDoc({ data: { data, cb } }) {
  try {
    const { docType, merchantVendorId } = data;
    const { url, method } = DOWNLOAD_DOC_URL;
    const updatedUrl = url.replace('$vendor_id$', merchantVendorId);
    const updatedUrlForDocDownload = updatedUrl.replace('$docType$', docType);
    const options = {
      method,
    };
    const response = yield call(request, updatedUrlForDocDownload, options);
    cb(response);
  } catch (err) {
    yield put(disableLoaderAction());
    showToast(err);
  }
}

export function* updateVendor({
  data: { data, actions, showVendorDbToggle, cb, errorCb, statusChange },
}) {
  try {
    const { url, method } = UPDATE_VENDOR_URL_NEW;
    const { merchantVendorId, vendorStatus, ...body } = data;
    let responseVendorById = {};
    if (statusChange) {
      const { url: vendorByIdUrl } = VENDOR_DATA_BY_ID_URL;
      const updatedUrlForVendorById = vendorByIdUrl.replace(
        '$vendor_id$',
        merchantVendorId,
      );
      const optionsForVendorById = { method: VENDOR_DATA_BY_ID_URL.method };
      responseVendorById = yield call(
        request,
        updatedUrlForVendorById,
        optionsForVendorById,
      );
      responseVendorById.scheduleOption =
        responseVendorById.schedule &&
        responseVendorById.schedule.scheduleId.toString();
    }
    let payload = {};
    if (vendorStatus === IN_BENE_CREATION) {
      IN_BENE_UPDATE_VENDOR_FIELDS.forEach(key => {
        payload[key] = body[key] || responseVendorById[key];
      });
    } else {
      UPDATE_VENDOR_FIELDS.forEach(key => {
        payload[key] = body[key] || responseVendorById[key];
      });
    }
    if (!statusChange) delete payload.status;
    if (showVendorDbToggle) {
      const { dashboardAccess } = body;
      payload = { ...payload, dashboardAccess };
    }

    const updatedUrl = url.replace('$vendor_id$', merchantVendorId);
    const options = {
      method,
      body: JSON.stringify(payload),
    };
    yield call(request, updatedUrl, options);
    if (cb) {
      yield put(
        showToast({
          message: 'Vendor Updated Successfully!',
          type: 'SUCCESS',
        }),
      );
      cb();
    }
  } catch (err) {
    yield put(showToast(err));
    if (actions) actions.setSubmitting(false);
    if (errorCb) errorCb(err);
  } finally {
    yield put(disableLoaderAction());
  }
}

export function* uploadKycData({
  data: { actions, cb, data, errCb, updatedBy, merchantVendorId },
}) {
  try {
    const promiseArr = [];
    const { url, method } = CREATE_KYC_URL;
    const updatedUrlForVendorById = url.replace(
      '$vendor_id$',
      merchantVendorId,
    );
    if (data) {
      const keys = Object.keys(data);
      keys.forEach(key => {
        if (data[key].type && data[key].size / (1024 * 1024) <= 25) {
          const fieldName = key;
          const file = data[key];
          const formData = new FormData();
          formData.append('file', file, file.name);
          formData.append('docType', fieldName);
          formData.append('updatedBy', updatedBy);
          promiseArr.push(
            // eslint-disable-next-line redux-saga/yield-effects
            call(request, updatedUrlForVendorById, { method, body: formData }),
          );
        }
      });
      yield all(promiseArr);
    }
    cb();
  } catch (err) {
    actions.setSubmitting(false);
    yield put(disableLoaderAction());
    if (err) errCb();
  }
}

export function* initiateVendorOd({ data }) {
  const { successCb, errorCb, ...body } = data;
  try {
    const { url, method } = INITIATE_VENDOR_OD_URL;
    const options = {
      method,
      body: JSON.stringify(body),
    };

    const response = yield call(request, url, options);

    successCb(response);
  } catch (err) {
    errorCb();
    yield put(showToast(err));
  }
}
export function* getVendorOdBalance({ data }) {
  const {
    successCb,
    errorCb,
    nextSettlementDate,
    resetLoader,
    ...queryObj
  } = data;
  try {
    const { url, method } = GET_VENDOR_OD_BALANCE_URL;
    const options = {
      method,
      queryString: queryObj || {},
    };

    const response = yield call(request, url, options);

    if (response && +response.existingVendorBalance >= MINIMUM_VENDOR_BALANCE) {
      successCb({
        ...response,
        nextSettlementDate,
        merchantVendorId: queryObj.merchantVendorId,
      });
    } else
      yield put(
        showToast({
          message:
            'On Demand amount for the interval can not be less than Rs 1000',
        }),
      );
  } catch (err) {
    errorCb();
    yield put(showToast(err));
  } finally {
    resetLoader(false);
  }
}

export function* getSettlementConfig() {
  try {
    const { url, method } = GET_SPLIT_VENDOR_OPTIONS_URL;
    const response = yield call(request, url, { method });
    const { availableSchedules } = response;
    yield put(saveSettlementConfigAction(availableSchedules));
  } catch (err) {
    showToast(err);
    disableLoaderAction();
  }
}

export function* getDocsByUser({
  data: { vendorId, accountType, businessType, cb },
}) {
  try {
    const { url, method } = GET_DOCS_BY_USER_URL;
    const updatedUrl = url.replace('$merchantVendorId$', vendorId);
    const options = {
      method,
      queryString: {
        userAccountType: accountType,
        userBusinessType: businessType,
      },
    };
    // clear the old data first
    yield put(saveVendorDocsAction({}));
    const response = yield call(request, updatedUrl, options);
    if ((!response || response?.documents?.length <= 0) && cb) {
      cb();
    } else {
      // yield put(saveVendorKycDetailsAction(response));
      yield put(saveVendorDocsAction(response));
    }
  } catch (err) {
    showToast(err);
    disableLoaderAction();
  }
}

export function* uploadVendorDocs({
  data: {
    userName,
    userAccountType,
    userBusinessType,
    payload,
    docNameTypeMapping,
    cb,
    updatedBy,
    actions,
  },
}) {
  try {
    const promiseArr = [];
    const { url, method } = UPLOAD_VENDOR_DOCS_URL;
    const options = {
      method,
      queryString: { userAccountType, userBusinessType },
    };
    const updatedUrl = url.replace('$userName$', userName);

    if (payload) {
      const inputKeys = Object.keys(payload.inputs);
      const fileKeys = Object.keys(payload.docs);

      inputKeys.forEach(key => {
        const docName = key;
        const docValue = payload.inputs[docName];
        const formData = new FormData();
        formData.append('docName', docName);
        formData.append('docValue', docValue);
        formData.append('docCategory', docNameTypeMapping[docName]);
        formData.append('docType', docName);
        formData.append('updatedBy', updatedBy);
        promiseArr.push(
          // eslint-disable-next-line redux-saga/yield-effects
          call(request, updatedUrl, { ...options, body: formData }),
        );
      });

      fileKeys.forEach(key => {
        const docName = key;
        const file = payload.docs[docName];
        const formData = new FormData();
        formData.append('file', file, file.name);
        formData.append('docCategory', docNameTypeMapping[docName]);
        formData.append('docType', docNameTypeMapping[docName]);
        formData.append('updatedBy', updatedBy);
        formData.append('docName', docName);
        promiseArr.push(
          // eslint-disable-next-line redux-saga/yield-effects
          call(request, updatedUrl, { ...options, body: formData }),
        );
      });
      yield all(promiseArr);
    }
    if (cb) cb();
  } catch (err) {
    if (actions) {
      actions.setSubmitting(false);
    }
    yield put(disableLoaderAction());
    yield put(showToast(err));
  }
}

export function* verifyPan({ data }) {
  try {
    const { payload, userAccountType, userBusinessType, cb } = data;
    const { url, method } = VERIFY_PAN_URL;
    const options = {
      method,
      queryString: { userAccountType, userBusinessType },
      body: JSON.stringify(payload),
    };
    const response = yield call(request, url, options);
    if (cb) cb(response);
  } catch (err) {
    yield put(disableLoaderAction());
    yield put(showToast(err));
  }
}

export function* verifyCin({ data }) {
  try {
    const { payload, userAccountType, userBusinessType, cb } = data;
    const { url, method } = VERIFY_CIN_URL;
    const options = {
      method,
      queryString: { userAccountType, userBusinessType },
      body: JSON.stringify(payload),
    };
    const response = yield call(request, url, options);
    if (cb) cb(response);
  } catch (err) {
    yield put(disableLoaderAction());
    yield put(showToast(err));
  }
}

export function* verifyGst({ data }) {
  try {
    const { payload, userAccountType, userBusinessType, cb } = data;
    const { url, method } = VERIFY_GST_URL;
    const options = {
      method,
      queryString: { userAccountType, userBusinessType },
      body: JSON.stringify(payload),
    };
    const response = yield call(request, url, options);
    if (cb) cb(response);
  } catch (err) {
    yield put(disableLoaderAction());
    yield put(showToast(err));
  }
}

export function* getVendorDataByIdSaga() {
  yield takeEvery(VENDOR_DATA_BY_ID, getVendorDataById);
}

export function* getVendorKycDetailsSaga() {
  yield takeEvery(GET_VENDOR_KYC_DETAILS, getVendorKycDetails);
}

export function* getKycDocsSaga() {
  yield takeEvery(GET_KYC_DOCS, getKycDocs);
}

export function* adjustBalanceSaga() {
  yield takeEvery(ADJUST_BALANCE, adjustBalance);
}

export function* downloadDocSaga() {
  yield takeEvery(DOWNLOAD_DOC, downloadDoc);
}

export function* updateVendorSaga() {
  yield takeEvery(UPDATE_VENDOR, updateVendor);
}

export function* uploadKycDataSaga() {
  yield takeEvery(UPLOAD_KYC_DATA, uploadKycData);
}

export function* getVendorOdBalanceSaga() {
  yield takeEvery(GET_VENDOR_OD_BALANCE, getVendorOdBalance);
}

export function* getSettlementConfigSaga() {
  yield takeEvery(GET_SETTLEMENT_CONFIG, getSettlementConfig);
}

export function* getDocsByUserSaga() {
  yield takeEvery(GET_DOCS_BY_USER, getDocsByUser);
}

export function* uploadVendorDocsSaga() {
  yield takeEvery(UPLOAD_VENDOR_DOCS, uploadVendorDocs);
}

export function* verifyPanSaga() {
  yield takeEvery(VERIFY_PAN, verifyPan);
}

export function* verifyGstSaga() {
  yield takeEvery(VERIFY_GST, verifyGst);
}

export function* verifyCinSaga() {
  yield takeEvery(VERIFY_CIN, verifyCin);
}

export function* initiateVendorOdSaga() {
  yield takeEvery(INITIATE_VENDOR_OD, initiateVendorOd);
}

// Individual exports for testing
export default function* easySplitDetailsSaga() {
  // See example in containers/HomePage/saga.js
  const sagas = [
    getVendorDataByIdSaga,
    getVendorKycDetailsSaga,
    getKycDocsSaga,
    adjustBalanceSaga,
    updateVendorSaga,
    downloadDocSaga,
    uploadKycDataSaga,
    getVendorOdBalanceSaga,
    getSettlementConfigSaga,
    getDocsByUserSaga,
    uploadVendorDocsSaga,
    verifyCinSaga,
    verifyGstSaga,
    verifyPanSaga,
    initiateVendorOdSaga,
  ];

  yield all(
    sagas.map(saga =>
      // eslint-disable-next-line func-names
      spawn(function*() {
        while (true) {
          try {
            yield call(saga);
            break;
          } catch (e) {
            // eslint-disable-next-line no-console
            console.log(e);
          }
        }
      }),
    ),
  );
}
